import { useState } from "react";
import { useClient } from "../../../../context/ClientContext";
import { actionZipCodeSearch } from "../../../../redux/address/actions";
import { useRedux } from "../../../../redux/hook/useRedux";
import { useGenericFormValidator } from "../../../../util/genericFormValidator";
import { creditFormEnum } from "../../../../model/enum";
import { Alert } from "../../../../util/Alert";
import { PutClientApi } from "../../../../service/controller/ClientsController";
import { useUserData } from "../../../../context/UserDataContext";


// 🔹 Regras de validação
const validationRulesProfile = {
    cpf: { required: true },
    nomeCompleto: { required: true },
    email: { required: true },
    telefone: { required: true },
    dataNascimento: { required: true },
    sexo: { required: true },
    nacionalidade: { required: true },
};

export function useMyProfile() {
    const { userData } = useUserData();
    const { client, setClient } = useClient();
    const { dispatch } = useRedux();

    //FORM ADDRESS
    const initialAddressForm = {
        cpf: client?.cpf,
        email: client?.email,
        fullName: client?.nomeCompleto,
        phone: client?.telefone,
        address: client?.endereco?.logradouro,
        cep: client?.endereco?.cep,
        city: client?.endereco?.cidade,
        complement: client?.endereco?.complemento,
        neighborhood: client?.endereco?.bairro,
        number: client?.endereco?.numero,
        uf: client?.endereco?.uf,
    }
    const validationRules = {
        address: {
            required: true
        },
        cep: {
            required: true
        },
        city: {
            required: true
        },
        uf: {
            required: true
        },
        complement: {
            required: false
        },
        neighborhood: {
            required: true
        },
        number: {
            required: true
        },
    }
    const { form: address, errors: addressErrors, handleChange, validate: validateAddressForm, setForm } = useGenericFormValidator(initialAddressForm, validationRules);

    const handleChangeCep = (e) => {
        const { value } = e.target;
        if (value.replaceAll('-', '').length == 8) {
            dispatch(actionZipCodeSearch(value, (response) => {
                const {
                    cep,
                    logradouro,
                    bairro,
                    localidade,
                    uf,
                } = response;
                setForm(prev => ({
                    ...prev,
                    cep: cep,
                    address: logradouro,
                    neighborhood: bairro,
                    city: localidade,
                    uf: uf
                }));
            }))
        } else {
            setForm(prev => ({
                ...prev,
                cep: value,
            }));
        }
        validateAddressForm({ cep: address.cep })
    }

    const addressInputs = [
        { label: 'CEP', name: 'cep', onChange: handleChangeCep, value: address.cep, placeholder: "xxxx-xxx", type: 'text' },
        { label: 'Endereço', name: 'address', onChange: handleChange, value: address.address, placeholder: "Rua xxxxx", type: 'text' },
        { label: 'Número', name: 'number', onChange: handleChange, value: address.number, placeholder: "0000", type: 'text' },
        { label: 'Complemento', name: 'complement', onChange: handleChange, value: address.complement, placeholder: "apartamento xx", type: 'text' },
        { label: 'Cidade', name: 'city', onChange: handleChange, value: address.city, placeholder: "XXXXX", type: 'text' },
        { label: 'Uf', name: 'uf', onChange: handleChange, value: address.uf, placeholder: "XX", type: 'text' },
        { label: 'Bairro', name: 'neighborhood', onChange: handleChange, value: address.neighborhood, placeholder: "XXXXX", type: 'text' },
    ]
    //DADOS PESSOAIS
    const initialIdentityForm = {
        nameMother: client?.nomeMae,
        cityBirth: client?.cidadeNascimento,
        ufBirth: client?.ufNascimento,
        number: client?.identidade?.numero,
        issuerCode: client?.identidade?.emissorCodigo,
        uf: client?.identidade?.uf,
        dateIssuer: client?.identidade?.dataEmissao?.split('T')[0],
        type: 'RG',
    }
    const validationRulesIdentity = {
        number: { required: true },
        issuerCode: { required: true },
        uf: { required: true },
        dateIssuer: { required: true },
        nameMother: { required: true },
        cityBirth: { required: true },
        ufBirth: { required: true },
        typeBenefit: {required: true }
    }
    const { form: identity, errors: identityErrors, handleChange: handleIdentityChange, validate: validateIdentityForm } = useGenericFormValidator(initialIdentityForm, validationRulesIdentity);
    const identityInputs = [        
        { label: 'Nome da mãe', name: 'nameMother', onChange: handleIdentityChange, value: identity.nameMother, placeholder: "xxxxxxxx", type: 'text' },
        { label: 'Cidade De Nascimento', name: 'cityBirth', onChange: handleIdentityChange, value: identity.cityBirth, placeholder: "xxxxxxxx", type: 'text' },
        { label: 'UF De Nascimento', name: 'ufBirth', onChange: handleIdentityChange, value: identity.ufBirth, placeholder: "xxxxxxxx", type: 'text', maxLength: 2 },
        { label: 'Número Da Identidade', name: 'number', onChange: handleIdentityChange, value: identity.number, placeholder: "xxxxxxxx", type: 'number' },
        { label: 'Emissor', name: 'issuerCode', onChange: handleIdentityChange, value: identity.issuerCode, placeholder: "xxxxx", type: 'text' },
        { label: 'Data Emissão', name: 'dateIssuer', onChange: handleIdentityChange, value: identity.dateIssuer, placeholder: "xx/xx/xxxx", type: 'date' },
        { label: 'Uf', name: 'uf', onChange: handleIdentityChange, value: identity.uf, placeholder: "xx", type: 'text', maxLength: 2 },
        { label: 'Tipo de Benefício', name: 'typeBenefit', oneChange: handleIdentityChange, value: identity.typeBenefit, placeholder: "xxxxxxxx", type: 'select' },
    ]
    //FORM BANK DETAILS
    const [creditForm, setCreditForm] = useState('');
    const [errosForm, setErrosForm] = useState({});
    const [typeAccount, setTypeAccount] = useState('');
    const [ufAccount, setUfAccount] = useState(client?.identidade?.ufContaBeneficio);
    const [bankDetails, setBankDetails] = useState({
        bankNumber: client?.identidade?.bancoNumero,
        numberAgency: client?.identidade?.agenciaNumero,
        agencyDigit: client?.identidade?.agenciaDV,
        accountNumber: client?.identidade?.contaNumero,
        accountDigit: client?.identidade?.contaDV,
    });
    const validateCreditForm = () => {
        const errors = {};

        if (!creditForm) errors.creditForm = 'Crédito é obrigatório';
        if (!typeAccount) errors.typeAccount = 'Tipo de conta é obrigatório';
        if (!ufAccount) errors.ufAccount = 'UF da conta é obrigatório';

        if (creditForm === creditFormEnum.bankTransfer.id) {
            if (!bankDetails.bankNumber) errors.bankNumber = 'Banco é obrigatório';
            if (!bankDetails.numberAgency) errors.numberAgency = 'Número da agência é obrigatório';
            if (!bankDetails.agencyDigit) errors.agencyDigit = 'Dígito da agência é obrigatório';
            if (!bankDetails.accountNumber) errors.accountNumber = 'Número da conta é obrigatório';
            if (!bankDetails.accountDigit) errors.accountDigit = 'Dígito da conta é obrigatório';

            // Apenas números
            const numberFields = ['bankNumber', 'numberAgency', 'accountNumber', 'agencyDigit', 'accountDigit'];
            numberFields.forEach(field => {
                if (bankDetails[field] && !/^\d+$/.test(bankDetails[field])) {
                    errors[field] = 'Apenas números são permitidos';
                }
            });
        }

        setErrosForm(errors);
        return {
            isValid: Object.keys(errors).length === 0,
            errors
        };
    };
    // Funções
    const onUpdateClientData = () => {
        const validateCredit = validateCreditForm();
        const validateAddress = validateAddressForm();
        const validateIdentity = validateIdentityForm();
        if (!validateCredit.isValid || !validateAddress || !validateIdentity) {
            return;
        }

        var requestPutUser = {
            ...client,
            nomeMae: identity.nameMother,
            cidadeNascimento: identity.cityBirth,
            ufNascimento: identity.ufBirth,
            TidpoBeneficioCodigo: identity.typeBenefit,
            "endereco": {
                "cep": address.cep,
                "logradouro": address.address,
                "numero": address.number,
                "complemento": address.complement,
                "bairro": address.neighborhood,
                "cidade": address.city,
                "uf": address.uf
            },
            "identidade": {
                "numero": identity.number,
                "emissorCodigo": identity.issuerCode,
                "uf": identity.uf,
                "dataEmissao": `${identity.dateIssuer}T00:00:00`,
                "tipo": "RG"
            },
            "contaCredito": {
                "bancoNumero": bankDetails.bankNumber ? bankDetails.bankNumber : "0",
                "agenciaNumero": bankDetails.numberAgency ? bankDetails.numberAgency : "0",
                "agenciaDV": bankDetails.agencyDigit ? bankDetails.agencyDigit : "0",
                "contaNumero": bankDetails.accountNumber ? bankDetails.accountNumber : "0",
                "contaDV": bankDetails.accountDigit ? bankDetails.accountDigit : "0",
                "ufContaBeneficio": ufAccount,
                "tipoConta": typeAccount
            }
        }
        PutClientApi(requestPutUser, userData.id, (data) => {
            setClient(data);
            Alert('Dados Atualizados com sucesso!');
        })
    }

    return {
        identityDetails: {
            identityInputs,
            identityErrors
        },
        addressDetails: {
            address,
            addressErrors,
            addressInputs
        },
        bankDetails: {
            creditForm,
            setCreditForm,
            typeAccount,
            setTypeAccount,
            ufAccount,
            setUfAccount,
            bankDetails,
            setBankDetails,
            errosForm,
            onSendProposal: onUpdateClientData
        },
        onUpdateClientData
    };
}
